import React from 'react';

export const listStyle: React.CSSProperties = {
   height: 200,
   overflowY: 'auto',
};
